import RadioButton from '@base/RadioButton/RadioButton';
import styled from '@emotion/styled';
import CheckedRadio from '@icon/CheckedRadio';
import EmptyRadio from '@icon/EmptyRadio';
import { Fonts, Spacings } from '@styles/index';
import { generateNextDays, generateStartOfToday } from '@utils/dates';
import { format as formatDate, isEqual } from 'date-fns';

const RadioGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-gap: ${Spacings.SPACING_8B};
  font-size: ${Fonts.SMALL};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  font-weight: ${Fonts.SEMIBOLD};
`;

const Radio = styled(RadioButton)<any>`
  .MuiButtonBase-root {
    color: var(--color-divider);
    margin-block-start: auto !important;
    margin-right: 14px !important;
  }
  .MuiTypography-body1 {
    font-size: ${Fonts.P1};
    font-weight: ${Fonts.SEMIBOLD};
  }

  .Mui-checked {
    color: var(--color-text-primary);
  }

  padding-right: 0px;
  margin-right: ${Spacings.SPACING_2B};
  color: var(--color-text-primary);
`;

const SelectDateForPlannerSection = ({ startDate, handleStartDateChange }) => {
  const today = generateStartOfToday();
  const next5Days = generateNextDays(5);
  return (
    <RadioGroup>
      {next5Days.map((currentDate) => {
        let dateString = formatDate(currentDate, 'd MMM');
        if (isEqual(currentDate, today)) dateString = `Today, ${dateString}`;
        return (
          <Radio
            key="radio-1"
            checked={isEqual(currentDate, startDate)}
            isSelected={isEqual(currentDate, startDate)}
            onChange={() => handleStartDateChange(currentDate)}
            label={dateString}
            icon={<EmptyRadio size="24px" color="var(--color-divider)" />}
            checkedIcon={
              <CheckedRadio size="24px" color="var(--color-text-primary)" />
            }
          />
        );
      })}
    </RadioGroup>
  );
};

export default SelectDateForPlannerSection;
